/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import Close from "@material-ui/icons/Close";
import { MEDIA_QUERY_FOR_PC } from "constants/mediaQueryForPc";
import { MEDIA_QUERY_FOR_SP } from "constants/mediaQueryForSp";
import { useI18n } from "hooks/i18n/i18n";
import React from "react";
import { colorTokens } from "theme/theme";

const cancelButtonStyles = css`
  align-items: center;
  background: none;
  border-radius: 6px;
  border: 0;
  color: ${colorTokens.colors["text.primary"].default};
  cursor: pointer;
  display: flex;
  justify-content: center;
  opacity: 1;
  padding: 8px 12px;
  width: 100%;

  ${MEDIA_QUERY_FOR_PC} {
    column-gap: 8px;
  }

  ${MEDIA_QUERY_FOR_SP} {
    column-gap: 6px;
  }
`;

const iconStyles = css`
  height: 16px;
  width: 16px;
`;

const cancelButtonTextStyle = css`
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  letter-spacing: 0;
`;

type CancelButtonProps = {
  onClick?: () => void;
};

export const CancelButton: React.FC<CancelButtonProps> = ({ onClick }) => {
  const { t } = useI18n();

  return (
    <button type="button" css={cancelButtonStyles} onClick={onClick}>
      <Close aria-hidden={true} css={iconStyles} />
      <span css={cancelButtonTextStyle}>
        {t("search.searchModal.footer.cancelSearch")}
      </span>
    </button>
  );
};
